import React, { useState } from 'react';
import { Button, Typography, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import FreeValuationForm from '../BookEvaluation';
import { Dialogue } from './Dialogue';
import logoVideo from '../../assets/videos/logo_video.mp4';

function Banner() {
  const [openEvaluation, setOpenEvaluation] = useState(false);
  const navigate = useNavigate();

  return (
    <div
      className="banner-area banner-area-1"
      style={{
        position: 'relative',
        height: '85vh',
        overflow: 'hidden',
      }}
    >
      {/* Background Video */}
      <video
        autoPlay
        loop
        muted
        playsInline
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          zIndex: -1,
        }}
      >
        <source src={logoVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Dark Overlay */}
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.2)',
          zIndex: 0,
        }}
      ></div>

      {/* Content Container */}
      <Box
        sx={{
          position: 'relative',
          zIndex: 1,
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          paddingLeft: { xs: '20px', sm: '40px', md: '80px', lg: '100px' },
          paddingRight: { xs: '20px', sm: '40px' },
        }}
      >
        {/* Main Heading */}
        <Typography
          variant="h1"
          sx={{
            fontSize: { xs: '2rem', sm: '3rem', md: '3.5rem', lg: '4rem' },
            fontWeight: '400',
            fontFamily: 'Georgia, serif',
            color: 'white',
            lineHeight: 1.2,
            marginBottom: '40px',
            maxWidth: '700px',
            textAlign: 'left',
            '@media (max-width: 600px)': {
              fontSize: '2rem',
              marginBottom: '30px',
            },
          }}
        >
          APCRDA Approved
          <br />
          Open Plots in Amaravati
        </Typography>

        {/* CTA Button */}
        <Button
          sx={{
            padding: '16px 40px',
            color: '#fff',
            backgroundColor: '#c9a961',
            fontSize: { xs: '0.9rem', sm: '1rem' },
            fontWeight: '600',
            textTransform: 'uppercase',
            letterSpacing: '1px',
            width: 'fit-content',
            border: 'none',
            '&:hover': {
              backgroundColor: '#b89850',
              transform: 'translateY(-2px)',
              transition: 'all 0.3s ease',
            },
          }}
          size="large"
          onClick={() => navigate('/contact')}
        >
          Learn More
        </Button>
      </Box>

      {/* Evaluation Form Dialog */}
      {openEvaluation && (
        <Dialogue open={openEvaluation} onClose={() => setOpenEvaluation(false)}>
          <FreeValuationForm onClose={setOpenEvaluation} />
        </Dialogue>
      )}
    </div>
  );
}

export default Banner;
